import ExportOrderButton from "../../rxcomponents/ExportOrderButton";
import React, {useEffect, useRef, useState} from "react";
import CustomRxPageHeader from "../../rxcomponents/CustomRxPageHeader";
import {Col, DatePicker, Form, Row, Select} from "antd";
import moment, {now} from "moment";
import {useIntl} from "react-intl";
import CurrencySelector from "../../components/CurrencySelector";
import ReactCountryFlag from "react-country-flag";
import {getCountryCodeForCurrency} from "../../utils/utils";
import {doLoadReportHistory, getTransferCalculatorConfiguration} from "../../api/api";
import {displayError, displayGenericError} from "../../common/notifications";
import ReportHistoryTable from "./ReportHistoryTable";

export function ReportPage(props) {

    const intl = useIntl();
    let fromVal = moment(now()).subtract(61, "days");
    let toVal = moment(now());
    const [from, setFrom] = useState(fromVal);
    const [to, setTo] = useState(toVal);
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const [pagination, setPagination] = useState({page: 0,size:10});
    const [reportHis, setReportHis] = useState([]);
    const [loading, setLoading] = useState(false);
    const [allowedCurrencies, setAllowedCurrencies]=useState(["ALL"]);
    const [selectedCurrency, setSelectedCurrency]=useState(["ALL"]);


    useEffect(()=>{
                console.log(reportType);
                const interval = setInterval(() => {
                    if(pagination.page==0) pagination.page=1
                    pagination['current']=pagination.page;
                    refreshPage(pagination);

                }, 30000)
                return () => {
                    clearInterval(interval);
                }
            }
    )

    useEffect(()=>{
        getTransferCalculatorConfiguration()
            .then(response => {
                let newAllowedSourceCurrencies = allowedCurrencies;
                for (let i = 0; i < response.transferRoutes.length; i++) {
                    let transferRoute = response.transferRoutes[i];
                    if (!newAllowedSourceCurrencies.includes(transferRoute.sourceCurrency)) {
                        newAllowedSourceCurrencies.push(transferRoute.sourceCurrency);
                    }
                }
                setAllowedCurrencies(newAllowedSourceCurrencies);
            })
            .catch(error => {
                displayGenericError(error)
            });

        doLoadReportHistory(page,size).then(res => {
                setReportHis(res.data);
                pagination.total = res.total;
                setPagination(pagination);
                setLoading(false)
        }).catch(error => {
            setLoading(false);
            displayError(JSON.stringify(error));
        });

    },[])
    const optionOrder = intl.formatMessage({id: "app.report.page.transaction.orders"});
    const optionCustomer = intl.formatMessage({id: "app.report.page.customer.statement"});
    const reportTypes =[
        {code: "24", value: optionOrder},
        {code: "1", value: optionCustomer},
    ]
    const [reportType, setReportType] = useState(reportTypes[0]);

    const reloadData = () =>{
        // this.getReportHistory(0, 10);
    }

    const handleTableChange = (pagination) => {
        setPagination(pagination);
        refreshPage(pagination);
    }

    const refreshPage = (pagination) => {
        if(pagination) {
            if(pagination.page) {
                pagination.current = pagination.page;
            }else {
                pagination.current = 1;
            }
        }else {
            pagination={current:1,page:page};
        }
        let code = reportType.code;
            doLoadReportHistory(pagination.current - 1, size).then(res => {
                setReportHis(res.data);
                pagination.total = res.total;
                setPagination(pagination);
                setLoading(false)
            }).catch(error => {
                setLoading(false);
                displayError(error);
            });
    }

    return (
        <>
            <div>
                <CustomRxPageHeader customer={props.customer}
                    title={intl.formatMessage({id: "app.sidebar.report"})}
                />
                <div className="bp-page-content bp-page-large">
                    <Row gutter={{xs: 4, sm: 8}}>
                        <Col className="gutter-row" md={{span: 4}} xs={{span: 18}}>
                            <Form.Item label= {`${intl.formatMessage({id: "app.report.page.select.report"})} *`}>
                                <Select
                                    showSearch
                                    style={{width: '100%'}}
                                    optionFilterProp="children"
                                    size={"large"}
                                    onChange={(value) => {
                                        let selectedReportType = reportTypes.find(item => item.code === value);
                                        setReportType(Object.create(selectedReportType));
                                    }}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    value={reportType.code}
                                >
                                    {reportTypes.map((reportType, idx) => {
                                        return <Select.Option value={reportType.code} key={reportType.code}>{reportType.value}</Select.Option>
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                        {reportType.code === "1" && <Col className="gutter-row" md={{span: 4}} xs={{span: 18}}>
                                <Form.Item label={intl.formatMessage({id: "app.common.currency"})}>
                                    <Select
                                        showSearch={window.innerWidth <= 600 ? false : true}
                                        style={{ width: "100%"}}
                                        defaultValue={selectedCurrency}
                                        size={"large"}
                                        onChange={value => setSelectedCurrency(value)}
                                        optionFilterProp="children"
                                        mode="multiple"
                                        filterOption={(input, option) =>
                                            option.props.children[1].props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0

                                        }
                                    >
                                        {allowedCurrencies.map((currency, idx) => {
                                            return (
                                                <Select.Option key={currency} currency={currency}>
                                                    <ReactCountryFlag code={getCountryCodeForCurrency(currency)} />
                                                    <span style={{marginLeft: "5px"}}>{currency}</span>
                                                </Select.Option>
                                            );
                                        })}
                                    </Select>
                                </Form.Item>
                        </Col>}
                    </Row>
                    <Row gutter={{xs: 4, sm: 8}}>
                        <Col md={{span: 4}} xs={{span: 18}}>
                            <Form.Item label={intl.formatMessage({id: "app.common.from"})} required="true">

                                <DatePicker
                                    size={"large"}
                                    style={{width: '100%'}}
                                    format={"YYYY/MM/DD"}
                                    value={from}
                                    onChange={(newValue) =>
                                        setFrom(newValue)
                                    }
                                />
                            </Form.Item>
                        </Col>
                        <Col md={{span: 4}} xs={{span: 18}}>
                            <Form.Item label={intl.formatMessage({id: "app.common.to"})} required="true">

                                <DatePicker
                                    size={"large"}
                                    style={{width: '100%'}}
                                    format={"YYYY/MM/DD"}
                                    value={to}
                                    onChange={(newValue) =>
                                        setTo(newValue)
                                    }
                                />
                            </Form.Item>
                        </Col>
                        <Col md={{span: 4}} xs={{span: 18}}>
                            <div style={{marginTop:40}}>
                            <ExportOrderButton
                                reportType={reportType.code}
                                currencies={selectedCurrency}
                                from={from}
                                to={to}
                                refreshPage={refreshPage}
                            />
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="bp-page-content bp-page-large">
                    <ReportHistoryTable
                        style={{marginTop: '5px'}}
                        onChange={handleTableChange}
                        reloadData={reloadData}
                        data={reportHis}
                        pagination={pagination}
                        isLoading={loading}/>
                </div>
            </div>
        </>
    );
}

export default ReportPage;

